import { AppConfig } from "../AppConfig";
import { ErrorCode, ErrorDetails, QuoteInstallmentsResponse } from "../Common/Types";
import { fetchRetry } from "../Common/services/FetchRetry";
import { convertToErrorDetails, logError, returnJsonOrThrowError } from "../Common/services/ErrorService";
import { AUTHORIZATION_SCHEME } from "./baseApi";
import { GenerateHeaderInformation } from "../Common/Helpers/ApiHelper";

/**
 * Fetches quote installment details from the quotation service.
 * GET /installments/{uuid}
 * Does not require a QuotationApi instance; safe to call from components without re-instantiation.
 */
export async function getQuoteInstallments(quoteId: string): Promise<QuoteInstallmentsResponse> {
  try {
    const token: string | null = sessionStorage.getItem(AppConfig.sessionStorageKeys.jwtToken);
    if (token == null) {
      console.error("Authentication token is missing. Please log in.");
      throw new ErrorDetails({
        code: ErrorCode.AuthenticationFailed,
        details: { additionalDetails: "Authentication token is missing. Please log in." },
      });
    }
    const url = `${AppConfig.api.quotation}/installments/${encodeURIComponent(quoteId)}`;
    const response = await fetchRetry(url, {
      method: "GET",
      headers: GenerateHeaderInformation(token, AUTHORIZATION_SCHEME),
    });
    const data = await returnJsonOrThrowError<QuoteInstallmentsResponse>(response);
    if (!data?.installments?.items?.length) {
      console.error("Quote installments response has an empty installments array", { quoteId });
    }
    return data;
  } catch (error) {
    const errorDetails = convertToErrorDetails(error, ErrorCode.InstallmentsFetchFailed);
    logError(errorDetails);
    throw errorDetails;
  }
}
